import { compose } from 'redux'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form'
import { getQueryParams } from 'selectors/getPageLocation'
import withRedirect from 'components/common/hoc/withRedirect'
import { isFieldActive } from 'selectors/redux-form'
import { FORM_NAME, PASSWORD_PROPERTY } from './constants'
import validate from './validatorConfig'
import form from './form'

// create redux-form selector
const selector = formValueSelector(FORM_NAME)

export default compose(
  withRedirect,
  reduxForm({ form: FORM_NAME, validate }),
  connect(state => ({
    values: selector(state, form.password.name, form.confirmPassword.name),
    queryParams: getQueryParams(state),
    isPasswordFieldActive: isFieldActive(FORM_NAME, PASSWORD_PROPERTY)(state)
  }))
)
